import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-jquiaccordion',
	templateUrl:'./JQUIAccordionPage.html',
	styles: [],
	styleUrls:['./JQUIAccordionPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIAccordionPage
{
	mdContent_177 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.accordion.JQUIAccordion;
\`\`\``;
	mdContent_178 = `\`\`\`java
new JQUIAccordion&lt;&gt;()
\`\`\``;
	mdContent_179 = `\`\`\`java
new JQUIAccordion&lt;&gt;(JQUIAccordionHeightStyle heightStyle)
\`\`\``;
	mdContent_180 = `\`\`\`java
var accordion = new JQUIAccordion<>();
var tab = new JQUIAccordionTab<>("Section 1", new Div<>().setText("Content"));
accordion.addAccordionTab(tab);
\`\`\``;
}
